<template>
  <button
    :type="type"
    :class="['button', { loading: loading }]"
    :disabled="disabled"
    @click="execute()"
  >
    {{ buttonText }}
    <svg
      v-if="loading"
      class="spinner"
      width="25"
      height="25"
      viewBox="0 0 50 50"
    >
      <circle
        class="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        :stroke="spinnerColor"
        stroke-width="5"
      ></circle>
    </svg>
  </button>
</template>

<script>
import EventBus from '@utils/bus';

export default {
  name: 'Button',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    strokeColor: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
  },
  computed: {
    buttonText() {
      return this.loading ? '' : this.value;
    },
  },
  data() {
    return {
      spinnerColor: 'white',
    };
  },
  created() {
    this.spinnerColor = this.strokeColor === '' ? 'white' : this.strokeColor;
  },
  methods: {
    execute() {
      if (
        this.name === 'find-id' ||
        this.name === 'find-password' ||
        this.name === 'join' ||
        this.name === 'fran-join'
      ) {
        EventBus.$emit(this.name);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  text-align: center;

  .spinner {
    position: relative;
    animation: rotate 2s linear infinite;
    display: flex;
    margin: auto;

    .path {
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }

  &.primary {
    .path {
      stroke: #fff;
    }
  }

  &.white {
    .path {
      stroke: $primary;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
}
</style>
